import { useMemo } from 'react';
import { angularService } from '../utils/angularBridge';

type Features = {
  ADW: boolean,
  RPA: boolean
}

/**
 * Get features flags from modules.json config
 */
export const getFeatures = (): Features => {
  const status = angularService('zStatus');
  return status.features || {};
};

/**
 * ADW is available
 */
export const useIsAdwAvailable = (): boolean => {
  // eslint-disable-next-line
  return useMemo(() => getFeatures().ADW || false, [ 1 ]);
};

export const isModelsAvailable = () => {
  try {
    return !!angularService('zStatus').endpoint.models;
  } catch (e) {
    return false;
  }
};

export const isRemoteFunctionsAvailable = isModelsAvailable;
